import styled from 'styled-components';

const ModalTitle = styled.h2`
  ${({ theme }) => theme.fontSize.M14};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-bottom: ${({ theme }) => theme.spacing.S12};
`;

const Items = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.S12};
`;

const Item = styled.li`
  ${({ theme }) => theme.fontSize.B14};
  display: flex;
  p {
    color: ${({ theme }) => theme.colors.GREY_DARKER};
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${({ theme }) => theme.spacing.S8};
`;

const Separator = styled.hr`
  border: none;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.GREY_LIGHT};
  margin: ${({ theme }) => theme.spacing.S12} 0;
`;

const BottomText = styled.p`
  ${({ theme }) => theme.fontSize.B14};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
`;

export { ModalTitle, Items, Item, IconWrapper, Separator, BottomText };
